<template>
    <div class="ggmf-card donations-chart-card">
        <div class="ggmf-card__header">
            <h4 class="ggmf-card__title">
                <i class="ri-bar-chart-grouped-line"></i>
                Doações por Mês
            </h4>
            <span class="ggmf-card__subtitle">Últimos 12 meses</span>
        </div>
        <div class="ggmf-card__body">
            <div v-if="loading" class="chart-skeleton"></div>
            <apexchart v-else type="bar" height="260" :options="chartOptions" :series="series" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DonationsChart',
    props: {
        donationsChart: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        series() {
            return [{
                name: 'Total (Kz)',
                data: this.donationsChart.map(d => d.total),
            }];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    height: 260,
                    toolbar: { show: false },
                    fontFamily: 'Inter, sans-serif',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 8,
                        columnWidth: '55%',
                    },
                },
                colors: ['#1765FD'],
                dataLabels: { enabled: false },
                xaxis: {
                    categories: this.donationsChart.map(d => {
                        const [year, month] = d.month.split('-');
                        const date = new Date(+year, +month - 1);
                        return date.toLocaleDateString('pt-PT', { month: 'short', year: '2-digit' });
                    }),
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                    labels: { style: { colors: '#9ca3af', fontSize: '11px' } },
                },
                yaxis: {
                    labels: {
                        style: { colors: '#9ca3af', fontSize: '11px' },
                        formatter: val => val.toLocaleString('pt-PT'),
                    },
                },
                grid: {
                    borderColor: '#F3F4F6',
                    strokeDashArray: 4,
                },
                tooltip: {
                    y: {
                        formatter: val => `${val.toLocaleString('pt-PT')} Kz`,
                    },
                },
            };
        },
    },
};
</script>

<style lang="scss">
.donations-chart-card {
    margin-bottom: 24px;
}

.chart-skeleton {
    height: 260px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    border-radius: 12px;
}
</style>
